import React, { Component } from 'react';
import moment from 'moment-timezone';
import CustomCheckbox from '../../../util_components/custom_checkbox';
import Button from '../../../util_components/button';
import CustomDatePicker from '../../../util_components/custom_date_picker';
import { get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import {
  build_active_packages_url,
  build_create_membership_payload,
  filter_create_membership_packages,
  format_package_charge_amount,
  get_selected_package,
  week_options
} from './create_membership_utils';

export default class CreateSubs extends Component {
  state = {
    active_packages: [],
    package_uuid: '',
    subscription_start_date: moment().format('YYYY-MM-DD'),
    number_of_week: 28,
    change_to_four_weeks_on_renewal: false,
    show_summary: false,
    loading_packages: true,
    error_message: ''
  };

  componentDidMount() {
    this.load_active_packages();
  }

  load_active_packages = () => {
    this.setState({ loading_packages: true, error_message: '' });
    const url = build_active_packages_url(get_api_url('active_packages'), this.props.student_uuid);
    get_api(url, true)
      .then((res) => {
        const active_packages = filter_create_membership_packages(res.data.packages || []);
        this.setState({
          active_packages,
          package_uuid: active_packages[0]?.uuid || '',
          loading_packages: false
        });
      })
      .catch((e) => {
        let error_message;
        try {
          error_message = e.response.data.message;
        } catch (err) {
          error_message = 'Failed to load active packages';
        }
        this.setState({ loading_packages: false, error_message });
      });
  };

  get_selected_package = () => {
    const { active_packages, package_uuid } = this.state;
    return get_selected_package(active_packages, package_uuid);
  };

  on_change = (e) => this.setState({ [e.target.name]: e.target.value });

  toggle_summary = () => this.setState({ show_summary: !this.state.show_summary });

  confirm_purchase = () => {
    const {
      package_uuid,
      subscription_start_date,
      number_of_week,
      change_to_four_weeks_on_renewal
    } = this.state;
    const payload = build_create_membership_payload({
      package_uuid,
      student_uuid: this.props.student_uuid,
      subscription_start_date,
      number_of_week,
      change_to_four_weeks_on_renewal,
      country: this.props.country
    });
    this.props.submit_subscription(payload);
  };

  render_summary = () => {
    const { subscription_start_date, number_of_week, change_to_four_weeks_on_renewal } = this.state;
    const selected_package = this.get_selected_package();
    const charge_amount = format_package_charge_amount(selected_package, number_of_week);
    return (
      <div className="create-membership-popup">
        <div className="create-membership-header">
          <h3>Confirm Membership Purchase</h3>
        </div>
        <div className="create-membership-summary">
          <div className="subs-summ">
            <span>Package</span>
            {selected_package.name}
          </div>
          <div className="subs-summ">
            <span>Subscription start date</span>
            {subscription_start_date}
          </div>
          <div className="subs-summ">
            <span>Number of weeks</span>
            {number_of_week}
          </div>
          <div className="subs-summ create-membership-charge-row">
            <span>User will be charged</span>
            {charge_amount}
          </div>
          <div className="subs-summ">
            <span>Change to 4 weeks on renewal</span>
            {change_to_four_weeks_on_renewal ? 'Yes' : 'No'}
          </div>
        </div>
        <div className="create-membership-actions">
          <button disabled={this.props.loading} onClick={this.confirm_purchase}>
            {this.props.loading ? 'Creating...' : 'Confirm'}
          </button>
          <button disabled={this.props.loading} onClick={this.toggle_summary}>
            Back
          </button>
        </div>
      </div>
    );
  };

  render_package_form = () => {
    const {
      active_packages,
      package_uuid,
      subscription_start_date,
      number_of_week,
      change_to_four_weeks_on_renewal,
      loading_packages,
      error_message
    } = this.state;
    const selected_package = this.get_selected_package();
    const charge_amount = format_package_charge_amount(selected_package, number_of_week);

    if (loading_packages) {
      return <div className="create-membership-loading">Loading packages...</div>;
    }

    if (error_message) {
      return (
        <div className="create-membership-error">
          <div>{error_message}</div>
          <Button onClick={this.load_active_packages}>Retry</Button>
        </div>
      );
    }

    return (
      <div className="create-membership-form">
        <div className="create-membership-field">
          <label>Package name</label>
          <select name="package_uuid" value={package_uuid} onChange={this.on_change}>
            {active_packages.map((active_package) => (
              <option key={active_package.uuid} value={active_package.uuid}>
                {active_package.name}
              </option>
            ))}
          </select>
          {!!selected_package.description && (
            <div className="cre-member-sub-heading">{selected_package.description}</div>
          )}
        </div>

        <div className="create-membership-field">
          <label>Subscription start date</label>
          <CustomDatePicker
            value={subscription_start_date}
            handleChange={(date) => this.setState({ subscription_start_date: date })}
            minDate={moment().format('YYYY-MM-DD')}
          />
        </div>

        <div className="create-membership-field">
          <label>Number of weeks</label>
          <select name="number_of_week" value={number_of_week} onChange={this.on_change}>
            {week_options.map((week) => (
              <option key={week} value={week}>
                {week}
              </option>
            ))}
          </select>
        </div>

        <div className="create-membership-charge">
          <span>User will be charged</span>
          <strong>{charge_amount}</strong>
        </div>

        <div className="create-membership-checkbox">
          <CustomCheckbox
            label="Change to 4 weeks on renewal"
            checked={change_to_four_weeks_on_renewal}
            onClick={() =>
              this.setState({
                change_to_four_weeks_on_renewal: !change_to_four_weeks_on_renewal
              })
            }
          />
        </div>

        <div className="create-membership-actions">
          <Button disabled={!package_uuid || this.props.loading} onClick={this.toggle_summary}>
            Continue
          </Button>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.show_summary) {
      return this.render_summary();
    }

    return (
      <div className="create-membership-popup">
        <div className="create-membership-header">
          <h3>Create Membership</h3>
        </div>
        {this.render_package_form()}
      </div>
    );
  }
}
